<template>
  <div class="app-container">
    <el-card class="box-card">
      <div class="machine-select-wrap">
        <span class="machine-select-label">{{ $t('CenterForSorting.currentDevice') }}</span>
        <el-select
          v-model="activeMachineId"
          :placeholder="$t('CenterForSorting.pleaseChoose')"
          filterable
          size="small"
          style="width: 280px"
          @change="handleMachineChange"
        >
          <el-option
            v-for="item in machineList"
            :key="item.id"
            :label="item.machineName"
            :value="String(item.id)"
          />
        </el-select>
      </div>

      <div
        class="toolbar"
        style="margin: 10px 0; display: flex; justify-content: space-between; align-items: center"
      >
        <div>
          <span style="font-weight: bold; margin-right: 30px; color: #05aa57">{{
            currentMachineObj.machineName
          }}</span>
          <span style="font-weight: bold; margin-right: 10px; color: #05aa57">{{
            currentMachineObj.machineCode
          }}</span>
          <span style="margin-left: 20px; font-weight: bold">
            {{
              enabledRuleGroupName
                ? $t('CenterForSorting.enabledRuleGroup') + ': ' + enabledRuleGroupName
                : $t('CenterForSorting.noEnabledRuleGroup')
            }}
          </span>
        </div>
        <div>
          <el-button
            v-if="isOperationBtnView" size="small" type="primary"
            @click="handleChuteView"
          >
            {{ $t('RouterObj.ChuteView') }}
          </el-button>
          <el-button
            v-permit:remove="'btn:sorting:ruleGroupList:add'"
            icon="el-icon-plus"
            size="small"
            type="primary"
            @click="handleAdd"
          >{{ $t('CenterForSorting.newRuleGroup') }}
          </el-button>
        </div>
      </div>

      <el-table
        v-loading="listLoading"
        :data="tableData"
        border
        fit
        highlight-current-row
        style="width: 100%"
      >
        <el-table-column
          :label="$t('CenterForSorting.ruleGroupName')"
          align="center"
          min-width="150"
          prop="groupName"
        />
        <el-table-column
          :label="$t('CenterForSorting.ruleGroupDesc')"
          align="center"
          min-width="200"
          prop="description"
        />
        <el-table-column
          :label="$t('CenterForSorting.ruleCount')"
          align="center"
          prop="ruleCount"
          width="100"
        />
        <el-table-column
          :label="$t('CenterForSorting.chuteCount')"
          align="center"
          prop="chuteCount"
          width="100"
        />
        <el-table-column :label="$t('CenterForSorting.State')" align="center" width="100">
          <template slot-scope="{ row }">
            <el-tag :type="row.status ? 'success' : 'info'">
              {{ row.status ? $t('CenterForSorting.enabled') : $t('CenterForSorting.disable') }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column
          :label="$t('CenterForSorting.ModificationTime')"
          align="center"
          prop="updateTime"
          width="160"
        />
        <el-table-column
          :label="$t('CenterForSorting.operation')"
          align="center"
          fixed="right"
          width="250"
        >
          <template slot-scope="{ row }">
            <el-button
              v-if="isOperationBtn"
              icon="el-icon-s-operation"
              size="mini"
              type="text"
              @click="handleSortingRules(row)"
            >{{ $t('CenterForSorting.sortingRules') }}
            </el-button>
            <el-button
              v-if="!row.status"
              v-permit:remove="'btn:sorting:ruleGroupList:status'"
              icon="el-icon-check"
              size="mini"
              type="text"
              @click="handleEnable(row)"
            >
              {{ $t('CenterForSorting.enable') }}
            </el-button>
            <el-button
              v-if="row.status"
              v-permit:remove="'btn:sorting:ruleGroupList:status'"
              icon="el-icon-close"
              size="mini"
              type="text"
              @click="handleDisable(row)"
            >
              {{ $t('CenterForSorting.disable') }}
            </el-button>
            <el-button
              v-permit:remove="'btn:sorting:ruleGroupList:edit'"
              icon="el-icon-edit"
              size="mini"
              type="text"
              @click="handleEdit(row)"
            >{{ $t('CenterForSorting.edit') }}
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页工具 -->
      <div class="pagination">
        <el-pagination
          :current-page.sync="listQuery.pageNumber"
          :page-size.sync="listQuery.pageSize"
          :page-sizes="[10, 20, 50, 100]"
          :total="total"
          background
          layout="total, sizes, prev, pager, next, jumper"
          style="margin: 10px 0"
          @current-change="fetchData"
          @size-change="fetchData"
        />
      </div>
    </el-card>

    <!-- 新增/编辑对话框 -->
    <el-dialog :title="textMap[dialogStatus]" :visible.sync="dialogFormVisible" width="500px">
      <el-form
        ref="dataForm" :model="temp" :rules="rules"
        label-position="top"
      >
        <el-form-item :label="$t('CenterForSorting.ruleGroupName')" prop="groupName">
          <el-input v-model="temp.groupName" :placeholder="$t('CenterForSorting.pleaseInput')" />
        </el-form-item>
        <el-form-item :label="$t('CenterForSorting.ruleGroupDesc')" prop="description">
          <el-input
            v-model="temp.description"
            :placeholder="$t('CenterForSorting.pleaseInput')"
            type="textarea"
          />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">{{ $t('CenterForSorting.cancel') }}
        </el-button>
        <el-button
          :loading="dialogBtnLoading"
          type="primary"
          @click="dialogStatus === 'create' ? createData() : updateData()"
        >
          {{ $t('CenterForSorting.confirm') }}
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getAllMachineList } from '@/api/sorting/machine';
import {
  addRuleGroup,
  disableRuleGroup,
  enableRuleGroup,
  getRuleGroupPage,
  updateRuleGroup
} from '@/api/sorting/ruleGroup';

export default {
  name: 'RuleGroupList',
  data() {
    return {
      machineList: [],
      activeMachineId: '',
      tableData: [],
      total: 0,
      listLoading: false,
      listQuery: {
        pageNumber: 1,
        pageSize: 10
      },
      dialogFormVisible: false,
      dialogStatus: '',
      textMap: {
        update: this.$t('CenterForSorting.editRuleGroup'),
        create: this.$t('CenterForSorting.newRuleGroup')
      },
      temp: {
        id: undefined,
        groupName: '',
        machineId: undefined,
        description: ''
      },
      dialogBtnLoading: false,
      rules: {
        groupName: [
          { required: true, message: this.$t('CenterForSorting.pleaseInput'), trigger: 'blur' }
        ]
      },
      isOperationBtn: false,
      isOperationBtnView: false,
      currentMachineObj: {}
    };
  },
  computed: {
    enabledRuleGroupName() {
      const enabledGroup = this.tableData.find((group) => group.status === 1);
      return enabledGroup ? enabledGroup.groupName : '';
    }
  },
  created() {
    this.initData();
    if (this.$store.state.user.roles.includes('menu:sorting:ruleList')) {
      this.isOperationBtn = true;
    } else {
      this.isOperationBtn = false;
    }
    if (this.$store.state.user.roles.includes('menu:sorting:chuteView')) {
      this.isOperationBtnView = true;
    } else {
      this.isOperationBtnView = false;
    }
  },
  methods: {
    async initData() {
      try {
        const res = await getAllMachineList();
        this.machineList = res.data || [];
        if (this.machineList.length > 0) {
          this.activeMachineId = String(this.machineList[0].id);
          this.currentMachineObj = this.machineList[0];
          this.fetchData();
        }
      } catch (error) {
        console.error(error);
      }
    },
    handleMachineChange() {
      this.listQuery.pageNumber = 1;
      const machine = this.machineList.find((m) => String(m.id) === this.activeMachineId);
      this.currentMachineObj = machine || {};
      this.fetchData();
    },
    fetchData() {
      if (!this.activeMachineId) return;
      this.listLoading = true;
      const params = {
        pageNumber: this.listQuery.pageNumber,
        pageSize: this.listQuery.pageSize,
        params: {
          machineId: this.activeMachineId
        }
      };
      getRuleGroupPage(params)
        .then((response) => {
          this.tableData = response.data.records;
          this.total = response.data.total;
          this.listLoading = false;
        })
        .catch(() => {
          this.listLoading = false;
        });
    },
    resetTemp() {
      this.temp = {
        id: undefined,
        groupName: '',
        machineId: Number(this.activeMachineId),
        description: ''
      };
    },
    handleChuteView() {
      this.$router.push({
        path: '/expressDataCenter/sortingManagementNew/chuteView',
        query: { machineId: Number(this.activeMachineId) }
      });
    },
    handleAdd() {
      if (!this.activeMachineId) {
        this.$message.warning(this.$t('CenterForSorting.pleaseChoose'));
        return;
      }
      this.resetTemp();
      this.dialogStatus = 'create';
      this.dialogFormVisible = true;
      this.$nextTick(() => {
        this.$refs['dataForm'].clearValidate();
      });
    },
    createData() {
      this.$refs['dataForm'].validate((valid) => {
        if (valid) {
          this.dialogBtnLoading = true;
          addRuleGroup(this.temp)
            .then(() => {
              this.dialogFormVisible = false;
              this.dialogBtnLoading = false;
              this.$notify({
                title: this.$t('CenterForSorting.success'),
                message: this.$t('CenterForSorting.createSuccess'),
                type: 'success',
                duration: 2000
              });
              this.fetchData();
            })
            .catch(() => {
              this.dialogBtnLoading = false;
            });
        }
      });
    },
    handleEdit(row) {
      this.temp = Object.assign({}, row);
      this.dialogStatus = 'update';
      this.dialogFormVisible = true;
      this.$nextTick(() => {
        this.$refs['dataForm'].clearValidate();
      });
    },
    updateData() {
      this.$refs['dataForm'].validate((valid) => {
        if (valid) {
          this.dialogBtnLoading = true;
          updateRuleGroup(this.temp)
            .then(() => {
              this.dialogFormVisible = false;
              this.dialogBtnLoading = false;
              this.$notify({
                title: this.$t('CenterForSorting.success'),
                message: this.$t('CenterForSorting.updateSuccess'),
                type: 'success',
                duration: 2000
              });
              this.fetchData();
            })
            .catch(() => {
              this.dialogBtnLoading = false;
            });
        }
      });
    },
    handleSortingRules(row) {
      this.$router.push({
        path: '/expressDataCenter/sortingManagementNew/ruleList',
        query: {
          ruleGroupId: row.id
        }
      });
    },
    handleEnable(row) {
      this.$confirm(
        this.$t('CenterForSorting.enableNewRuleGroupNotice'),
        this.$t('CenterForSorting.tips'),
        {
          confirmButtonText: this.$t('CenterForSorting.sure'),
          cancelButtonText: this.$t('CenterForSorting.cancel'),
          type: 'warning'
        }
      ).then(() => {
        enableRuleGroup({ id: row.id }).then(() => {
          this.$message.success(this.$t('CenterForSorting.enableSuccess'));
          this.fetchData();
        });
      });
    },
    handleDisable(row) {
      this.$confirm(
        this.$t('CenterForSorting.disableRuleGroupConfirm'),
        this.$t('CenterForSorting.tips'),
        {
          confirmButtonText: this.$t('CenterForSorting.sure'),
          cancelButtonText: this.$t('CenterForSorting.cancel'),
          type: 'warning'
        }
      ).then(() => {
        disableRuleGroup({ id: row.id }).then(() => {
          this.$message.success(this.$t('CenterForSorting.disableSuccess'));
          this.fetchData();
        });
      });
    }
  }
};
</script>

<style scoped>
.machine-select-wrap {
  display: flex;
  align-items: center;
  margin-bottom: 16px;
}

.machine-select-label {
  margin-right: 12px;
  font-weight: bold;
}

.toolbar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}
</style>
